<template>
  <div>
    <b-button class="typo-butt-command mr-1 ml-1 mt-3 but-oval" @click="apriModalParametri">
      <i class="fas fa fa-1x fa-sliders mr-2"></i>
      {{$t("param_button.text")}}
    </b-button>

    <!-- Parametri impianto Modal-->
    <b-modal
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      :id="'modal-parametri-impianto'+this._uid"
      :title="$t('parametri_impianto_modal.title')"
      :ok-title="$t('parametri_impianto_modal.button_salva')"
      :cancel-title="$t('parametri_impianto_modal.button_cancel')"
      @ok="handleOk"
    >
      <b-form-group>
        <label>{{$t("parametri_impianto_modal.label_autonomy")}}</label>
        <b-form-select v-model="lampAutonomy">
          <option value></option>
          <option value="1H">1H</option>
          <option value="1H5">1H5</option>
          <option value="2H">2H</option>
          <option value="3H">3H</option>
          <option value="8H">8H</option>
        </b-form-select>
        <label class="mt-4">{{$t("parametri_impianto_modal.label_parity")}}</label>
        <b-form-select v-model="lampParity">
          <option value></option>
          <option value="PARI">{{$t("param_lamp.PARI")}}</option>
          <option value="DISPARI">{{$t("param_lamp.DISPARI")}}</option>
        </b-form-select>
        <label class="mt-4">{{$t("parametri_impianto_modal.label_mode")}}</label>
        <b-form-select v-model="lampMode">
          <option value></option>
          <option value="SE">SE</option>
          <option value="SA">SA</option>
          <option value="PS">PS</option>
        </b-form-select>
        <label v-if="this.configView !=null" class="mt-4" for="label-cu-type">
          {{$t("parametri_impianto_modal.label_infinity")}}
          <div v-if="this.configView.includes('mix')" style="color:grey;font-size:12px"><i class="fa fa-exclamation-triangle mr-1"></i>{{$t("parametri_impianto_modal.warning_infinity")}}</div>
        </label>
        <b-form-select v-if="this.configView !=null" v-model="lampInfinity">
          <option value></option>
          <option value="ON">ON</option>
          <option value="OFF">OFF</option>
        </b-form-select>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ParametriImpianto",
  data() {
    return {
      lampAutonomy: "",
      lampParity: "",
      lampMode: "",
      lampInfinity: "",
      footer_hide: false
    };
  },
  props: {
    cu:null,
    lamp:null,
    group:null,
    alerts:null,
    configView: null,
    sendAction: null
  },
  methods: {
     apriModalParametri() {
       console.log("apro modal param ",this.group);
       console.log("config View: ", this.configView);
      if (this.cu.length>0 || this.lamp.length>0)
      {
        console.log("Selezionate", this.cu, this.lamp);
        this.lampAutonomy ="";
        this.lampParity ="";
        this.lampMode ="";
        this.lampInfinity ="";
        this.$bvModal.show('modal-parametri-impianto'+this._uid);
        
      }
      else
      {
        var alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: this.$t('parametri_impianto_modal.error_select'),
                    countDownChanged: function(cd) {
                    }
                }
        this.alerts.push(alert);     
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveParam();
    },
    saveParam() {
      if (
        this.lampAutonomy != "" ||
        this.lampParity != "" ||
        this.lampInfinity != "" ||
        this.lampMode != ""
      ) {
        var params = {};
        params.command = "setMultiParam";
        params.autonomy = this.lampAutonomy;
        params.parity = this.lampParity;
        params.mode = this.lampMode;
        params.infinity = this.lampInfinity;
        params.opticom = "";
        params.durataTest = "";
        params.uvOxyOnOff = "";
        params.uvOxyTimer = "";
        params.uvOxyFanSpeed = "";
        this.sendAction(params);

        // Hide the modal manually
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },

    OnlyHexInString(hex) {
      return !isNaN(Number("0x" + hex));
    }
  }
};
</script>
